import queryString from 'query-string';

export function parseQueryToField<T>(query: string, fields: string[]): { [x in keyof T]: string | undefined } {
  const result: any = {};
  const parsed = queryString.parse(query);

  fields.forEach((field) => {
    //@ts-ignore
    result[field] = parsed[field]
  });

  return result
}

export function appendQuery(query: string, label: string, value: string) {
  const parsed = new URLSearchParams(query);

  if (parsed.has(label)) {
    parsed.set(label, value);
  } else {
    parsed.append(label, value);
  }

  return parsed
}

export function replaceQueryUrlState(queryName: string, queryVal: string) {
  const updatedUrl = `${window.location.pathname}?${String(appendQuery(window.location.search, queryName, queryVal))}`;

  return window.history.replaceState({}, '', updatedUrl)
}
